/* eslint-disable import/no-anonymous-default-export */
/*
 * @Author: klcxkjhsm huangshimin@klcxkj.com
 * @Date: 2023-07-31 11:32:39
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2025-11-20 12:25:31
 * @FilePath: \app-client-h5\src\api\http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { detectUserPlatform } from '../utils/util';
import axios from 'axios'
import envConfig from '../config/env';
const http = axios.create({
    baseURL: envConfig.api,// 环境地址统一在 src/config/env.js 中配置切换
    timeout: 5000,
    withCredentials: true
})
http.interceptors.request.use((config) => {
    if (config.method === 'get') {
    } else if (config.method === 'post') {
        config.headers['content-type'] = 'application/x-www-form-urlencoded';
    }
    return config
}, (err) => {
    return Promise.reject(err)
})
http.interceptors.response.use((res) => {
    if (res.status === 200) {
        return res.data
    }
}, (err) => {
    return Promise.reject(err)
})
export default (method, url, data) => {
    if (method === 'get') {
        // 如果data中已经有phoneSystem，使用它；否则自动检测
        const platform = detectUserPlatform(data?.phoneSystem);
        // 只有在phoneSystem不为null时才设置
        if (platform && data) {
            data.phoneSystem = platform
        } else if (platform && !data) {
            // 检查URL中是否已包含phoneSystem参数，避免重复添加
            if (!url.includes('phoneSystem=')) {
                if (url.includes('?')) {
                    url = url + '&phoneSystem=' + platform;
                }
            }
        }
        return http.get(url, {
            params: data
        })
    } else if (method === 'post') {
        // 如果data中已经有phoneSystem，使用它；否则自动检测
        const platform = detectUserPlatform(data?.phoneSystem);
        if (platform && data) {
            data.phoneSystem = platform
        } else if (platform && !data) {
            // 检查URL中是否已包含phoneSystem参数，避免重复添加
            if (!url.includes('phoneSystem=')) {
                if (url.includes('?')) {
                    url = url + '&phoneSystem=' + platform;
                }
            }
        }
        return http.post(url, data)
    }
}